export const pageTitle = (title) => {
  return (document.title = title + ' - Nha khoa LC Dental');
};
